export const validateFields = (formData, fields) => {
    const errors = {};
  
    fields.forEach(({ name, label }) => {
      const fieldKeys = name.split("."); // Support nested fields
      let value = formData;
  
      for (const key of fieldKeys) {
        if (value && Object.prototype.hasOwnProperty.call(value, key)) {
          value = value[key];
        } else {
          value = undefined;
          break;
        }
      }
  
      if (!value || (Array.isArray(value) && value.length === 0)) {
        errors[name] = `${label} is required`;
      }
    });
  
    return errors;
  };
  